export default class Beer {

    constructor() {
        this.category = "";
        this.name = "";
        this.alcVol = "";
        this.wortVol = "";
        this.spices = "";
        this.beerType = "";
        this.barrelType = "";
        this.barrelPrevContent = "";
        this.barrelPrevContentText = "";
        this.alternativeCereal = "";
        this.belgianBeerType = "";
        this.media_file = "";
        this.query_response = "";
    }
}